import { Address, getContract, namehash, PublicClient } from 'viem'

import { resolverAbi } from '../constants/abis/ensPublicResolver'
import { registrarAbi } from '../constants/abis/ensRegistrar'

const REGISTRAR_ADDRESS = '0xCfb86556760d03942EBf1ba88a9870e67D77b627'

const ENS_NAME_REGEX = /^(([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+)eth(\/.*)?$/

/** cache the resolver contracts since most of them are the public resolver
 * @param {string}resolverAddress
 * @param {PublicClient}publicClient
 * @return {Contract}
 */
function resolverContract(resolverAddress: Address, publicClient: PublicClient) {
  return getContract({
    address: resolverAddress,
    abi: resolverAbi,
    publicClient: publicClient as PublicClient,
  })
}

/**
 * Fetches and decodes the result of an ENS contenthash lookup on mainnet to a URI
 * @param {string}ensName to resolve
 * @param {PublicClient} publicClient Client to use to fetch the data
 */
export async function resolveENSContentHash(ensName: string, publicClient: PublicClient) {
  const ensRegistrarContract = getContract({
    address: REGISTRAR_ADDRESS as Address,
    abi: registrarAbi,
    publicClient: publicClient,
  })
  const hash = namehash(ensName)
  const resolverAddress = (await ensRegistrarContract.read.resolver([hash])) as Address
  return resolverContract(resolverAddress, publicClient).read.contenthash([hash])
}

/**
 * @param {string}ensAddress
 * @return {{Ensname: string, ensPath: string} | undefined }
 */
export function parseENSAddress(
  ensAddress: string
): { ensName: string; ensPath: string | undefined } | undefined {
  const match = ensAddress.match(ENS_NAME_REGEX)
  if (!match) return undefined
  return { ensName: `${match[1].toLowerCase()}bch`, ensPath: match[4] }
}
